var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 0H8C3.58172 0 0 3.58172 0 8V122C0 126.418 3.58172 130 8 130H122C126.418 130 130 126.418 130 122V8C130 3.58172 126.418 0 122 0Z",
    fill: "#FFA178"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.4375 31C75.699 31 74.1223 32.0512 73.4484 33.6684C72.7746 35.2855 73.152 37.1318 74.3783 38.3717L79.9576 43.9375L57.1418 66.7668C55.4572 68.4514 55.4572 71.1871 57.1418 72.8717C58.8264 74.5563 61.5621 74.5563 63.2467 72.8717L86.0625 50.0424L91.6418 55.6217C92.8816 56.8615 94.7279 57.2254 96.3451 56.5516C97.9623 55.8777 99.0135 54.3145 99.0135 52.5625V35.3125C99.0135 32.9271 97.0863 31 94.701 31H77.4375ZM40.7812 35.3125C34.8246 35.3125 30 40.1371 30 46.0938V89.2188C30 95.1754 34.8246 100 40.7812 100H83.9062C89.8629 100 94.6875 95.1754 94.6875 89.2188V74.125C94.6875 71.7396 92.7604 69.8125 90.375 69.8125C87.9896 69.8125 86.0625 71.7396 86.0625 74.125V89.2188C86.0625 90.4047 85.0922 91.375 83.9062 91.375H40.7812C39.5953 91.375 38.625 90.4047 38.625 89.2188V46.0938C38.625 44.9078 39.5953 43.9375 40.7812 43.9375H55.875C58.2604 43.9375 60.1875 42.0104 60.1875 39.625C60.1875 37.2396 58.2604 35.3125 55.875 35.3125H40.7812Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white",
    transform: "translate(30 31)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.48111cfb02d15544ec278b673002aaac.svg";
export { ForwardRef as ReactComponent };